import { render, staticRenderFns } from "./AppForbidden.vue?vue&type=template&id=a8da1cb6&scoped=true"
import script from "./AppForbidden.vue?vue&type=script&lang=js"
export * from "./AppForbidden.vue?vue&type=script&lang=js"
import style0 from "./AppForbidden.vue?vue&type=style&index=0&id=a8da1cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8da1cb6",
  null
  
)

export default component.exports